import {
    BaseEdge,
    getStraightPath,
    //   useReactFlow,
  } from "@xyflow/react";
  
  const handleStyle = { stroke: "green",strokeWidth: 1 };
  
  function CustomBackEdge({
    id,
    sourceX,
    sourceY,
    targetX,
    targetY,
    markerEnd,
    markerStart,
    
  }) {
    //   const { setEdges } = useReactFlow();
    const [edgePath] = getStraightPath({
      sourceX,
      sourceY,
      targetX,
      targetY,
    });
    //
    return (
      <>
        <BaseEdge
          id={id}
          path={edgePath}
          style={handleStyle}
          markerEnd={markerEnd}
          markerStart={markerStart}
        />
        
      </>
    );
  }
  //
  export default CustomBackEdge;
  